import { render, staticRenderFns } from "./plataccount-withdrawal.vue?vue&type=template&id=a8a9facc&scoped=true&"
import script from "./plataccount-withdrawal.vue?vue&type=script&lang=js&"
export * from "./plataccount-withdrawal.vue?vue&type=script&lang=js&"
import style0 from "./plataccount-withdrawal.vue?vue&type=style&index=0&id=a8a9facc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a9facc",
  null
  
)

export default component.exports